<div [ngClass]="{ 'about' : state === 'about'}" class="footer">
  &copy; 2023 - Akiru Studios AB
</div>
